import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { MailboxIcon } from "lucide-react";

export function RetractationOption() {
  return (
    <Label htmlFor="retractation">
      <Option>
        <OptionIcon>
          <MailboxIcon />
        </OptionIcon>
        <OptionTitle>Exercer mon droit de rétractation</OptionTitle>
        <OptionDescription>
          Vous avez le droit de vous rétracter dans les 14 jours suivant votre achat
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="retractation" id="retractation" />
        </OptionAction>
      </Option>
    </Label>
  );
}
